import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AdminSidebar } from '../components/shared/AdminSidebar';
import { AdminTopbar } from '../components/shared/AdminTopbar';
import { useAuthContext } from '../context/AuthProvider';

const TITULOS: Record<string, string> = {
  '/admin': 'Dashboard',
  '/admin/catalogo': 'Gestión de Catálogo',
  '/admin/categorias': 'Gestión de Categorías',
  '/admin/pedidos': 'Gestión de Pedidos',
  '/admin/cuentas': 'Gestión de Cuentas',
  '/admin/cambiar-password': 'Cambiar Contraseña',
};

export function AdminLayout() {
  const { sesion } = useAuthContext();
  const { pathname } = useLocation();
  const [menuAbierto, setMenuAbierto] = useState(false);

  if (!sesion) return <Navigate to="/admin/login" replace />;

  // FR-ID-02/BR-ID-01: la ruta de cuentas solo es visible para Administrador
  // (espejo de UX — el backend re-valida con 403 si se accede directamente).
  if (pathname.startsWith('/admin/cuentas') && sesion.rol !== 'Administrador') {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="flex min-h-screen bg-admin-bg">
      <AdminSidebar abierto={menuAbierto} onCerrar={() => setMenuAbierto(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <AdminTopbar
          titulo={TITULOS[pathname] ?? 'Panel Administrativo'}
          onAbrirMenu={() => setMenuAbierto(true)}
        />
        <main className="p-4 md:p-10 overflow-x-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
